import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Typography from '@mui/material/Typography';
import { useEffect } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { NETWORK_SEARCH_LANGUAGES } from './networkSearchLanguages';

const LanguageServices = () => {
	const languages = NETWORK_SEARCH_LANGUAGES;

	const { language } = useParams();
	const location = useLocation();

	useEffect(() => {
		const requestedLanguage =
			location.state?.scrollToLanguageId || language;

		if (!requestedLanguage) {
			return;
		}

		const isValidLanguage = languages.some(
			lang => lang.id === requestedLanguage
		);
		if (!isValidLanguage) {
			return;
		}

		const languageSection = document.getElementById(
			`language-${requestedLanguage}`
		);
		if (languageSection) {
			languageSection.scrollIntoView({
				behavior: 'smooth',
				block: 'start',
			});
		}
	}, [language, location.key, location.state, languages]);

	return (
		<>
			<Typography variant='h4'>Language Access Services</Typography>
			<List disablePadding>
				{languages.map(lang => (
					<ListItem
						id={`language-${lang.id}`}
						key={lang.id}
						disableGutters
						alignItems='flex-start'
						sx={{
							display: 'block',
							py: 1,
							scrollMarginTop: '80px',
						}}
					>
						<Typography fontWeight='bold'>
							{lang.language}
						</Typography>
						<Typography>{lang.text}</Typography>
					</ListItem>
				))}
			</List>
		</>
	);
};

export default LanguageServices;
